import React from "react";
import moment from "moment";

const FieldCard = ({label, value}) => (
	<div className="rounded-lg border border-[#E9E9E9] bg-white p-4">
		<p className="text-xs font-semibold uppercase tracking-wide text-[#7A7A7A]">{label}</p>
		<p className="mt-2 text-sm font-medium text-[#1E1F21]">{value || "-"}</p>
	</div>
);

function StudioDataScreen({setIsVisible, item}) {
	if (!item) {
		return (
			<div className="p-6">
				<div className="flex items-center justify-between">
					<h2 className="text-2xl font-semibold text-[#096730]">Studio Details</h2>
					<button type="button" onClick={() => setIsVisible(false)} className="text-sm font-semibold text-[#6D6E6F]">
						Close
					</button>
				</div>
				<p className="mt-8 text-sm text-[#6D6E6F]">No studio selected.</p>
			</div>
		);
	}

	return (
		<div className="max-h-[80vh] overflow-y-auto">
			<div className="sticky top-0 z-10 flex items-center justify-between border-b border-[#E4E1E0] bg-white px-6 py-4">
				<h2 className="text-2xl font-semibold text-[#096730]">Studio Details</h2>
				<button
					type="button"
					onClick={() => setIsVisible(false)}
					className="rounded-md px-2 py-1 text-[#6D6E6F] hover:bg-[#F5F5F5]"
				>
					<svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M18.707 5.293a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414-1.414l12-12a1 1 0 0 1 1.414 0Z"
							fill="#6D6E6F"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M5.293 5.293a1 1 0 0 1 1.414 0l12 12a1 1 0 0 1-1.414 1.414l-12-12a1 1 0 0 1 0-1.414Z"
							fill="#6D6E6F"
						/>
					</svg>
				</button>
			</div>

			<div className="space-y-6 p-6">
				<div className="overflow-hidden rounded-xl border border-[#E4E1E0] bg-white">
					<div className="relative h-52 w-full bg-[#1E1F21]">
						<img
							src={item.artwork_url}
							alt={item.name}
							className="h-full w-full object-cover opacity-80"
						/>
						<div className="absolute inset-0 bg-gradient-to-t from-[rgba(0,0,0,0.6)] to-transparent" />
						<div className="absolute bottom-4 left-4 right-4">
							<h3 className="text-3xl font-semibold text-white">{item.name}</h3>
							<p className="mt-1 text-sm text-white/90">{item.address || "No address provided"}</p>
						</div>
					</div>
					<div className="grid grid-cols-1 gap-3 p-4 md:grid-cols-3">
						<div className="rounded-lg bg-[#F7FAF8] px-3 py-2">
							<p className="text-xs font-semibold uppercase text-[#7A7A7A]">Owner</p>
							<p className="mt-1 text-sm font-medium text-[#1E1F21]">{item.user?.name || "-"}</p>
						</div>
						<div className="rounded-lg bg-[#F7FAF8] px-3 py-2">
							<p className="text-xs font-semibold uppercase text-[#7A7A7A]">Email</p>
							<p className="mt-1 text-sm font-medium text-[#1E1F21]">{item.user?.email || "-"}</p>
						</div>
						<div className="rounded-lg bg-[#F7FAF8] px-3 py-2">
							<p className="text-xs font-semibold uppercase text-[#7A7A7A]">Created</p>
							<p className="mt-1 text-sm font-medium text-[#1E1F21]">
								{item.created_at ? moment.utc(item.created_at).local().format("MMM D, YYYY") : "-"}
							</p>
						</div>
					</div>
				</div>

				<div>
					<h4 className="mb-3 text-lg font-semibold text-[#1E1F21]">Business Information</h4>
					<div className="grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-3">
						<FieldCard label="Business Incorporation" value={item.name} />
						<FieldCard label="Studio Type" value={item.category?.name} />
						<FieldCard label="Account Type" value="Business" />
						<FieldCard label="Tax ID" value="0018190002-133" />
						<FieldCard label="Location" value={item.address} />
						<FieldCard
							label="Added In"
							value={item.created_at ? moment.utc(item.created_at).local().format("MMM D, YYYY") : "-"}
						/>
					</div>
				</div>
			</div>
		</div>
	);
}

export default StudioDataScreen;
